import React, { useEffect, useState } from "react";
import { useIntersectionObserver } from "@lkf/hooks";
import Loading from "@ui-kit/loading";

interface IProps {
  children: React.ReactNode;
  loading: boolean;
  forceReload?: boolean;
}

const RadarlySharedWidgetsLoading = ({
  children,
  loading,
  forceReload,
}: IProps) => {
  const { ref, inView } = useIntersectionObserver();
  const [isFirstMount, setFirstMount] = useState(true);
  useEffect(() => {
    if (isFirstMount && !loading) {
      setFirstMount(false);
    }
  }, [isFirstMount, loading]);
  const isWidgetDisplayed = isFirstMount || forceReload ? !loading : true;
  return (
    <div ref={ref} style={{ width: "100%", height: "100%" }}>
      <Loading isVisible={inView ? loading : true} />
      {inView && isWidgetDisplayed && children}
    </div>
  );
};

export default RadarlySharedWidgetsLoading;
